/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import { createAgent } from '@vlinder-web/plugin-agent-service-react';
import {
  LoadingMyProfilePlugin,
  ILoadingMyProfilePluginMethods,
  ErrorContentPlugin,
  IErrorContentPluginMethods,
  StaticPagePlugin,
  IStaticPagePluginMethods,
  IFeatureProfilePluginMethods,
  FeatureProfilePlugin,
  UpdateProfilePlugin,
  IUpdateProfilePluginMethods,
} from './plugins';

export type TAgent = IStaticPagePluginMethods &
  ILoadingMyProfilePluginMethods &
  IErrorContentPluginMethods &
  IFeatureProfilePluginMethods &
  IUpdateProfilePluginMethods;

const getPlugins = () => {
  return [
    new StaticPagePlugin(),
    new ErrorContentPlugin(),
    new LoadingMyProfilePlugin(),
    //Business logic plugins !
    new FeatureProfilePlugin(),
    new UpdateProfilePlugin(),
  ];
};

export const getAgent = () => {
  return createAgent<TAgent>({
    plugins: getPlugins(),
  });
};
